module.exports = __webpack_public_path__ + "img/Map Copy.ee1bd892.svg";